import React from "react";
import { Link } from "react-router-dom";

function FooterOne() {
  return (
    <footer className="footer-modern">
      {/* TOP SECTION */}
      <div className="fm-container">
        <div className="fm-grid">
          {/* BRAND */}
          <div className="fm-col">
            <img src="/assets/img/logo3.svg" alt="logo" className="fm-logo" />

            <p className="fm-desc">
              Your trusted destination for high-quality printers, accessories,
              and printing essentials. Smart technology made simple.
            </p>
          </div>

          {/* LINKS 1 */}
          <div className="fm-col">
            <h4 className="fm-title">Quick Links</h4>
            <ul className="fm-links">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms-and-conditions">Terms & Conditions</Link>
              </li>
              <li>
                <Link to="/return-policy">Return Policy</Link>
              </li>
            </ul>
          </div>

          {/* LINKS 2 */}
          <div className="fm-col">
            <h4 className="fm-title">Customer Support</h4>
            <ul className="fm-links">
              <li>
                <Link to="/track-order">Track Order</Link>
              </li>
              <li>
                <Link to="/return-order">Return & Exchange</Link>
              </li>
              <li>
                <Link to="/contact">Help Center</Link>
              </li>
              <li>
                <Link to="/shipping-policy">Shipping Policy</Link>
              </li>
              <li>
                <Link to="/cookie-policy">Cookie Policy</Link>
              </li>
            </ul>
          </div>

          {/* CONTACT */}
          <div className="fm-col">
            <h4 className="fm-title">Contact Us</h4>
            <ul className="fm-contact">
              <li>
                <i className="fa-solid fa-phone"></i> +1-512-744-7593
              </li>
              <li>
                <i className="fa-solid fa-envelope"></i> info@howlywizard.com
              </li>
              <li>
                <i className="fa-solid fa-location-dot"></i> 520 Juliette Way
                Apt 5409 Cedar Park, Tx 78613
              </li>
            </ul>
          </div>
        </div>

        {/* TRUST BOX */}
        <div className="fm-trust">
          <div className="fm-badge">
            <i className="fa-solid fa-shield"></i>
            Secure Checkout
          </div>

          <div className="fm-badge">
            <i className="fa-solid fa-truck"></i>
            Fast Delivery
          </div>

          <div className="fm-badge">
            <i className="fa-solid fa-headset"></i>
            24/7 Support
          </div>
        </div>

        {/* DISCLAIMER */}
        <div className="fm-disclaimer">
          <h5>
            <i className="fa-solid fa-circle-info"></i> Legal Disclaimer
          </h5>
          <p>
            Howly Wizard is an independent retailer and is not affiliated with
            HP or any other printer brand. All trademarks belong to their
            respective owners. Products include standard manufacturer warranties
            and are sourced through authorized suppliers.
          </p>
        </div>
      </div>

      {/* BOTTOM BAR */}
      <div className="fm-bottom">
        <p>© {new Date().getFullYear()} Howly Wizard. All Rights Reserved.</p>

        <div className="fm-payments">
          <span>Secure Payments</span>
          <img src="/assets/img/payment-method.png" alt="payment icons" />
        </div>
      </div>

      {/* === SCOPED CSS === */}
      <style>{`
        .footer-modern {
          background: #000;
          color: #d4d4d4;
          padding-top: 70px;
        }

        .fm-container {
          max-width: 1250px;
          margin: auto;
          padding: 0 20px;
        }

        .fm-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 40px;
          margin-bottom: 40px;
        }

        /* BRAND */
        .fm-logo {
          width: 150px;
          margin-bottom: 15px;
        }

        .fm-desc {
          font-size: 14px;
          line-height: 1.6;
          color: #bbb;
          max-width: 260px;
        }

        /* TITLES */
        .fm-title {
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 12px;
          color: #fff;
        }

        /* LINKS */
        .fm-links li {
          margin-bottom: 8px;
          list-style: none;
        }

        .fm-links a {
          color: #cfcfcf;
          text-decoration: none;
          transition: 0.25s;
        }

        .fm-links a:hover {
          color: #4C8BF5;
        }

        /* CONTACT */
        .fm-contact li {
          list-style: none;
          margin-bottom: 10px;
          line-height: 1.5;
        }

        .fm-contact i {
          margin-right: 10px;
          color: #4C8BF5;
        }

        /* TRUST BADGES */
        .fm-trust {
          display: flex;
          gap: 20px;
          justify-content: center;
          margin: 40px 0;
          flex-wrap: wrap;
        }

        .fm-badge {
          background: #1a1a1a;
          padding: 12px 20px;
          border-radius: 8px;
          font-size: 14px;
          border: 1px solid #2a2a2a;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .fm-badge i {
          color: #4C8BF5;
        }

        /* DISCLAIMER */
        .fm-disclaimer {
          background: #ffffff10;
          padding: 18px;
          border-radius: 8px;
          margin-bottom: 40px;
          color: #ccc;
        }

        .fm-disclaimer h5 {
          font-size: 16px;
          margin-bottom: 8px;
          color: #fff;
        }

        .fm-disclaimer i {
          color: #4C8BF5;
          margin-right: 6px;
        }

        /* FOOTER BOTTOM */
        .fm-bottom {
          background: #0b0b0b;
          padding: 16px 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          border-top: 1px solid #222;
        }

        .fm-bottom p {
          color: #ccc;
          margin: 0;
          font-size: 14px;
        }

        .fm-payments img {
          height: 28px;
          margin-left: 10px;
        }

        .fm-payments span {
          margin-right: 8px;
          color: #aaa;
        }

        @media (max-width: 576px) {
          .fm-bottom {
            text-align: center;
            flex-direction: column;
            gap: 10px;
          }
        }
      `}</style>
    </footer>
  );
}

export default FooterOne;
